const utcStamp = /\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?Z/g;

export function formatUtcStamps(value: string): string {
  if (!value) {
    return '';
  }

  return value.replace(utcStamp, (stamp) => {
    const parsed = new Date(stamp.includes('T') ? stamp : stamp.replace(' ', 'T'));
    if (Number.isNaN(parsed.getTime())) {
      return stamp;
    }

    return parsed.toLocaleString();
  });
}

export function iconForNavItem(screenKey: string, openMode: string): string {
  switch (screenKey) {
    case 'Automic':
      return 'dashboard';
    case 'AutomicExecutions':
      return 'checklist';
    case 'ContactSearch':
      return 'person_search';
    case 'CorrelationSearch':
      return 'account_tree';
    case 'MonitoredResources':
      return 'monitor_heart';
    case 'MonthEnd':
      return 'event_note';
    default:
      return openMode === 'NewTab' ? 'open_in_new' : 'language';
  }
}

export function isHttpsUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

export function readHttpError(error: unknown, fallback = 'Request failed.'): string {
  if (typeof error === 'object' && error !== null && 'error' in error) {
    const body = (error as { error?: unknown }).error;
    if (typeof body === 'string' && body.trim()) {
      return body;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
}

export function svgIconForNavItem(screenKey: string): string | null {
  switch (screenKey) {
    case 'Automic':
      return 'automic';
    default:
      return null;
  }
}
